import { Supplier } from './Supplier';

export const SingleSupplier = () => {
  return <Supplier />;
};
